import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { Tooltip } from '../../../../components/Tooltip';

function PageDescription({ title, description, withBackOption, withForwardOption, link, tooltipText }) {
    const navigate = useNavigate()
    return (
        <div className="card bg-gradient-to-r from-theme_clr1 to-theme_clr2 rounded-xl mb-5 p-4 lg:p-5 pb-9">
            <div className="flex items-center justify-between">
                <h5 className="text-white text-[23px] font-manrope font-bold leading-tight mb-[11px]">
                    {title}
                </h5>

                {/* <div>
                    {withBackOption &&
                        <Tooltip 
                            text={'Go Back'}
                            style={{ bg: "bg-theme_clr1", text: "text-white", width: "w-24" }}
                        >
                            <button
                                onClick={() => navigate(-1)}
                                className="text-white hover:opacity-80 transition"
                            >
                                <i class="bi bi-arrow-left text-2xl"></i>
                            </button>
                        </Tooltip>
                    }
                    {withForwardOption && 
                        <Tooltip 
                            text={tooltipText}
                            style={{ bg: "bg-theme_clr1", text: "text-white", width: "w-32" }}
                        >
                            <button
                                onClick={() => navigate(link)}
                                className="text-white hover:opacity-80 transition ml-4"
                            >
                                <i class="bi bi-arrow-right text-2xl"></i>
                            </button>
                        </Tooltip>
                    }
                </div> */}
            </div>

            <div className="text-white text-xl font-jakarta">
                {description}
            </div>
        </div>

    );
}
PageDescription.propTypes = {
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
};

export default PageDescription;